
import Driver from 'driver.js';
import { mapActions, mapGetters } from 'vuex';
import { validateAccess } from '../libs/helpers';
import Contact from '../components/ContactComponent.vue';
import MyStatus from './status/MyStatus.vue';
import Reception from '../components/ReceptionComponent.vue';
import TechnicalReport from './reports/TechnicalReport.vue';
import NotAuthorized from './budgets/NotAuthorized.vue';
import _const from '../const';
import EventBus from '../events';
import DetailsCarComponent from '../components/DetailsCarComponent.vue';
import NoticeOfPrivacy from '../components/NoticeOfPrivacy.vue';
import InvoiceSection from '../components/invoice/InvoiceSection.vue';
import STATE_STATUSES from '../store/state-statuses';

export default {
  name: 'HomeClient',
  components: {
    Contact,
    MyStatus,
    Reception,
    TechnicalReport,
    NotAuthorized,
    DetailsCarComponent,
    NoticeOfPrivacy,
    InvoiceSection,
  },
  data: () => ({
    showDetail: false,
    showReception: true,
    showNotAuthorized: false,
    showPaymentOrder: false,
    activity: {},
    redActivities: [],
    yellowActivities: [],
    greenActivities: [],
    isExpandedCard: true,
    isExpandedCardActivities: true,
    intervalId: null,
    fromChecklist: false,
    reset: true,
    isStartTutorial: false,
    isFinishTutorial: false,
    isChecklistEnabled: false,
    isActivitiesEnabled: false,
    positionTop: 'top-center',
    finishedLoad: false,
    brand: '',
    isPrivacyShow: false,
    orderId: '',
    email: '',
    isNotInternal: Boolean,
  }),
  computed: {
    ...mapGetters('Order', {
      isMainOrderClosedStatus: 'getIsMainOrderClosedStatus',
      isMainOrderClosed: 'getIsMainOrderClosed',
    }),

    desktop() {
      return this.$q.screen.gt.md;
    },
    tablet() {
      return this.$q.screen.lt.lg && this.$q.screen.gt.sm;
    },
    mobile() {
      return this.$q.screen.lt.md;
    },

    isInvoiceEnabled() {
      return this.isMainOrderClosed && this.isMainOrderClosedStatus === STATE_STATUSES.SUCCESS;
    },
  },
  created() {
    this.enterSystem();
    this.brand = this.$session.get('brand') !== '' ? this.$session.get('brand') : process.env.VUE_APP_BRAND;
    const isInternal = Boolean(Number(localStorage.getItem('isInternal')));
    this.isNotInternal = !isInternal;
  },
  async mounted() {
    this.triggerIsMainOrderClosed({
      superOrderIdDms: this.$session.get('superOrderId'),
      email: this.$session.get('email'),
      dealerId: this.$session.get('dealerId'),
    });

    this.orderId = this.$session.get('orderIdDMS').toString();
    this.email = this.$session.get('email');
    if (localStorage.getItem('originAuth') === null && localStorage.getItem('isInternal') === '0') {
      this.$store.commit('SET_LAYOUT', this.getEnvironmentLayoutName());
    } else if (localStorage.getItem('originAuth') === null && localStorage.getItem('isInternal') === '1') {
      window.location.href = `/login_grp?orderId=${localStorage.getItem('superOrderId')}&email=${this.$session.get('email')}&userInternalId=${this.$session.get('userInternalId')}&token=${this.$session.get('token')}`;
    } else {
      localStorage.removeItem('originAuth');
    }
    EventBus.$on('validateViews', this.changeViewsEnabled);
    await this.getOrderDetailDms();

    const parentSuperorderId = JSON.parse(localStorage.getItem('parentSuperOrderId'));
    if (parentSuperorderId) {
      await this.getParentSuperorderChecklistActivities(parentSuperorderId);
    }
  },
  methods: {
    ...mapActions('Order', ['getOrderDetailDms', 'triggerIsMainOrderClosed']),
    ...mapActions('Activity', ['getParentSuperorderChecklistActivities']),

    updatePrivacy(dataUpdated) {
      const { privacy, transferData } = dataUpdated;
      this.isPrivacyShow = !(privacy && transferData);
    },
    enterSystem() {
      const privacy = this.$session.get('privacy');
      const transferData = this.$session.get('transferData');
      this.isPrivacyShow = !(privacy && transferData);
    },
    changeViewsEnabled() {
      this.isChecklistEnabled = validateAccess(_const.MODULE_ADDITIONAL_BUDGETS);
      this.isActivitiesEnabled = validateAccess(_const.MODULE_ACTIVITIES);
      this.finishedLoad = true;
    },
    showReport(data) {
      if (data != null) {
        this.isExpandedCard = false;
        this.showDetail = true;
        this.showReception = false;
        this.showNotAuthorized = false;
        this.activity = data.activity.activity ?? data.activity;
        window.scrollTo(0, data.heightImage);
        if (this.isActivitiesEnabled && this.tablet && document.getElementById('startAct')) {
          document.getElementById('startAct').scrollIntoView(true);
        }
      }
    },
    closeReport() {
      this.showDetail = false;
      this.showReception = true;
      this.reset = !this.reset;
    },
    closeNotAuthorized() {
      this.showNotAuthorized = false;
      this.showReception = true;
      this.reset = !this.reset;
    },
    closeTutorial() {
      this.isFinishTutorial = false;
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
    },
    initTutorial() {
      this.isStartTutorial = false;

      const driver = new Driver({
        className: 'tutorial',
        padding: 1,
        doneBtnText: 'Siguiente >',
        closeBtnText: 'Cerrar',
        nextBtnText: 'Siguiente >',
        prevBtnText: '< Anterior',
        opacity: 0.2,
      });

      driver.defineSteps([
        {
          element: '#status-container',
          popover: {
            title: '¡Checa el estatus de tu vehículo!',
            description: 'Aquí podrás ver en tiempo real el avance de el servicio de tu vehículo',
            position: this.positionTop,
            className: 'status-container',
          },
        },
        {
          element: '#contact-container',
          popover: {
            title: '¡Ponte en contacto con tu asesor!',
            description:
                'Ponemos a tu disposición el nombre de tu asesor y los botones de contacto para cualquier duda o aclaración',
            position: this.positionTop,
            className: 'contact-container',
          },
        },
        {
          element: '#reception-container',
          popover: {
            title: 'Revisa los datos de tu vehículo',
            description: 'Checa los datos de tu vehículo y los tuyos desde este panel',
            position: this.positionTop,
            className: 'reception-container',
          },
        },
        {
          element: '#pay-container',
          popover: {
            title: 'Realiza tu pago',
            description:
                'Ya no tienes que hacer fila, realiza tu pago remotamente y solo acude a recoger y revisar el servicio de tu vehículo',
            position: this.positionTop,
            className: 'pay-container',
          },
          onNext: () => {
            this.isFinishTutorial = true;
          },
        },
      ]);

      driver.start();
    },
  },
};
